import { render, staticRenderFns } from "./food-account.vue?vue&type=template&id=4a76e4ac"
import script from "./food-account.vue?vue&type=script&lang=js"
export * from "./food-account.vue?vue&type=script&lang=js"
import style0 from "./food-account.vue?vue&type=style&index=0&id=4a76e4ac&prod&lang=scss"
import style1 from "./food-account.vue?vue&type=style&index=1&id=4a76e4ac&prod&midia=print&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports